module.exports = __webpack_public_path__ + "static/media/crossword.4e23498d.jpg";